import React from 'react';
import Lottie from 'lottie-react';
import { useLanguage } from '../../context/LanguageContext';
import LanguageSwitcher from '../UI/LanguageSwitcher';
import spinnerAnimation from './spinner.json';

const LoadingDialog: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div className="loading-dialog">
      <div className="dialog-header">
        <LanguageSwitcher />
      </div>
      <div className="loading-dialog__content-wrapper">
        <div className="loading-dialog__icon">
          <div className="loading-dialog__icon-inner">
            <Lottie
              animationData={spinnerAnimation}
              loop={true}
              style={{ width: 56, height: 56 }}
            />
          </div>
        </div>

        <div className="loading-dialog__content">
          <h2 className="loading-dialog__title">{t('preparingPayment')}</h2>
          <p className="loading-dialog__desc">{t('pleaseWait')}</p>
        </div>
      </div>
    </div>
  );
};

export default LoadingDialog;
